import React from 'react';
import { Flex, Spinner, useToast } from '@chakra-ui/react';
import { keepPreviousData } from '@tanstack/react-query';
import { getGetInspectionDetailQueryKey, useGetAllInspections, } from '../../../../services/api/generated/client';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { useInspectionListingContext } from './InspectionListingProvider';
import { buildPaginationFromResponse } from '../../../../services/pagination';
import { ErrorAwareAlertBox } from '../../../modules/ErrorAwareAlertBox/ErrorAwareAlertBox';
import { localise, templateReplace } from '../../../../services/lang/lang';
import useSorting from '../../../../hooks/useSorting';
import { FIVE_MIN_STALE_TIME, queryClient, } from '../../../../services/api/query/queryClient';
import InspectionsTable from '../../../modules/InspectionsTable/InspectionsTable';
const InspectionListingContent = ({ searchQuery, page, incrementPage, decrementPage, selectedColumns, selectedActionIds, }) => {
    const { sortFormatted, sortOptions, handleSort } = useSorting();
    const toast = useToast();
    const { scope, status } = useInspectionListingContext();
    const { data: response, isFetching, refetch, isError, error, } = useGetAllInspections({
        scope,
        should_paginate: 1,
        page,
        'filter[status_id]': [status],
        'filter[search_query]': searchQuery,
        sort: sortFormatted,
        'filter[action_type_id]': selectedActionIds,
    }, {
        query: {
            placeholderData: keepPreviousData,
            staleTime: FIVE_MIN_STALE_TIME,
        },
        axios: { headers: { 'api-version': 'v3' } },
    });
    if (isError || error) {
        return React.createElement(ErrorAwareAlertBox, { noun: localise('INSPECTIONS'), error: error });
    }
    const inspections = unwrapModel(response);
    if (!inspections && isFetching) {
        return React.createElement(Spinner, { "data-testid": "loading_spinner", size: "lg" });
    }
    const pagination = buildPaginationFromResponse(response, incrementPage, decrementPage);
    const onInspectionMutated = (inspection) => {
        toast({
            title: templateReplace(localise('UPDATED'), {
                noun: localise('INSPECTION'),
            }),
            status: 'success',
            isClosable: true,
        });
        queryClient.invalidateQueries({
            queryKey: getGetInspectionDetailQueryKey(inspection.id),
        });
        refetch();
    };
    return (React.createElement(Flex, { w: "full", "data-testid": "inspection-listing-content" },
        React.createElement(InspectionsTable, { onInspectionMutated: onInspectionMutated, scope: scope, selectedColumns: selectedColumns, isFetching: isFetching, inspections: inspections, pagination: pagination, currentSortOptions: sortOptions, onSort: handleSort })));
};
export default InspectionListingContent;
